module.exports = __webpack_public_path__ + "img/kongtiaotuli.53d2d2ed.png";